import React, { Component } from 'react';

class SelectPartner extends Component {
    _onClick = () => {
        this.props.selectPartner(this.props.partner.id);
    };
    render() {
        return (
            <li
                onClick={this._onClick}
                className={`ckp-events-filter-option ${
                    this.props.partner.id === this.props.selected ? 'is-selected' : ''
                }`}
            >
                {this.props.partner.name}
            </li>
        );
    }
}

export default SelectPartner;
